<div class="container-fluid">
    <div>
        <app-outward-header (searchByName)="searchOfficeByName($event)" [tableSettings]="tableSetting.columns"></app-outward-header>
    </div>
    <div class="mt-1">
  <table class="table">
      <thead>
          <tr >
              <td class="w-8" *ngFor="let column of tableSetting.columns;let i = index">
                    <div *ngIf="column.isSortable">
                      
                        <span class="columheader" style="cursor:pointer">{{column.title}}</span>                   
                        <span class="icon-ic_filtered column-filter-icon cursor-pointer"  (click)="showSortingPopup(column)" *ngIf="column.isFilterIcon"></span>
                        
                    </div>
                    <div  *ngIf="!column.isSortable">
                        <span class="columheader">{{column.title}}</span>
                    </div>
                    <div class="resource-dropdown" *ngIf="column.displaysort">
                        <app-outward-filter [registrationArray] = "registrationArray" [statusArray] = "statusArray"
                        [column]="column" [tableSettings]="tableSetting" 
                        (gridFiltersApplied)="checkFilterApplied($event)"></app-outward-filter>   
                    </div>
              </td>
          </tr>
      </thead>
      <tbody class="results-list-panel">          
                <div class="no-search-results"  *ngIf="((usersList!=null)&&(usersList.length==0))">
                    <img src="../../../../assets/images/No results.png" width="240px" height="200px"/>
                    <label style="color:black;line-height: 24px;font-weight: 600;">No registration to display</label>
                    <label>No registrations have been added to this<br/> list. To add new registration click the button<br/> below</label>
                    <br/>
                    <button routerLink="/AddOutward" routerLinkActive="active" class="button" type="button" style="border: 1px solid #007CB0;background-color: #fff;color: #007CB0;">New Registration</button>
                </div>
                <tr *ngFor="let consent of usersList | paginate: { itemsPerPage: 10, currentPage: p, totalItems: totalCount};let i = index" tooltip="Click to View Details">

          <td class="tablewidth" (click)="detailedIOnfo(consent.requestId)">
            <span class="showellipsis"  >{{consent.serialNumber ? consent.serialNumber  : '-'}}</span>
          </td>

          <td class="tablewidth" (click)="detailedIOnfo(consent.requestId)">
            <span class="showellipsis" tooltip="{{consent.gatepassNo}}" >{{consent.gatepassNo ? consent.gatepassNo  : '-'}}</span>
          </td>
          <td class="tablewidth" (click)="detailedIOnfo(consent.requestId)">
            <span class="showellipsis" style="width:109px;" tooltip="{{consent.requestName}}">{{consent.requestName ? consent.requestName  : '-'}}</span>
          </td>
          <td class="tablewidth" (click)="detailedIOnfo(consent.requestId)">
            <span class="showellipsis"  >{{consent.requestTypeName ? consent.requestTypeName  : '-'}}</span>
          </td>
         
          <td class="tablewidth" (click)="detailedIOnfo(consent.requestId)">
            <div [ngClass]="{'bg-created':consent.statusId===OutwardStatus.Created,'bg-received':consent.statusId===OutwardStatus.Received,'bg-superApproved':consent.statusId===OutwardStatus.Supervisor,'bg-appr1':consent.statusId===OutwardStatus.LAapprover1,'bg-appr2':consent.statusId===OutwardStatus.LAapprover2,'bg-printPass':consent.statusId===OutwardStatus.PrintPass,'bg-cancelled':consent.statusId===OutwardStatus.Cancelled,'bg-declined':consent.statusId===OutwardStatus.Declined}">
            <span class="showellipsis"   >{{consent.status ? consent.status  : '-'}}</span>
            <a *ngIf="consent.statusId==OutwardStatus.Created" class='tooltip-test'>
              <img  src="../../../../assets/images/info.svg"  style="width: 21px;" />
              <span>
                <img src="../../../../assets/images/created.png" style="width:625px;right:25px;">
              </span>
              </a>

              <a *ngIf="consent.statusId==OutwardStatus.LAapprover1" class='tooltip-test'>
                <img  src="../../../../assets/images/info.svg"  style="width: 21px;" />
                <span>
                  <img src="../../../../assets/images/Laappr1.PNG" style="width:625px;right:25px;">
                </span>
                </a>

                <a *ngIf="consent.statusId==OutwardStatus.LAapprover2" class='tooltip-test'>
                  <img  src="../../../../assets/images/info.svg"  style="width: 21px;" />
                  <span>
                    <img src="../../../../assets/images/laapr2.PNG" style="width:625px;right:25px;">
                  </span>
                  </a>
               
                <a *ngIf="consent.statusId==OutwardStatus.Supervisor" class='tooltip-test'>
                  <img  src="../../../../assets/images/info.svg"  style="width: 21px;" />
                  <span>
                    <img src="../../../../assets/images/supervisor.PNG" style="width:625px;right:25px;">
                  </span>
                  </a>
                  <a *ngIf="consent.statusId==OutwardStatus.PrintPass" class='tooltip-test'>
                    <img  src="../../../../assets/images/info.svg"  style="width: 21px;" />
                    <span>
                      <img src="../../../../assets/images/passprinted.PNG" style="width:625px;right:25px;">
                    </span>
                    </a>

            <i *ngIf="consent.statusId==OutwardStatus.Cancelled" placement="right" tooltip="{{consent.declinedByNotes}}" style="border-width:1px 0 0;margin-left:-9px;left:125px;">
              <img  src="../../../../assets/images/info.svg"  style="width: 21px;" /></i>
              <i *ngIf="consent.statusId==OutwardStatus.Declined" placement="right" tooltip="{{consent.declinedByNotes}}" style="border-width:1px 0 0;margin-left:-9px;left:125px;">
                <img  src="../../../../assets/images/info.svg"  style="width: 21px;" /></i>

                <a *ngIf="consent.statusId==OutwardStatus.Received" class='tooltip-test'>
                  <img  src="../../../../assets/images/info.svg"  style="width: 21px;" />
                  <span>
                    <img src="../../../../assets/images/received.PNG" style="width:625px;right:25px;">
                  </span>
                  </a>
              
          </div>
          </td>
         
          <td class="tablewidth" style="width: 190px;" (click)="detailedIOnfo(consent.requestId)">
            <span>{{consent.requestDateTime ? (consent.requestDateTime  | date:'d/MMM/y, h:mm a') : '-'}}</span>
          </td>
          <td style="width: 190px;" (click)="detailedIOnfo(consent.requestId)" class="text-truncate" *ngIf="!(duedatecomparer>consent.returnDateTime) && (consent.statusId!=OutwardStatus.Received || consent.statusId!=OutwardStatus.Cancelled)">
            <span  *ngIf="consent.requestTypeName != 'Non-Returnable'" [ngStyle]="{'color': consent.duedatebeforetwodays ? '#FFBF00' : 'black'}">{{consent.returnDateTime | date:'d/MMM/y, h:mm a'}}</span>
            <span style="display: flex;justify-content: center;" class="showellipsis" *ngIf="consent.requestTypeName == 'Non-Returnable'">-</span>                                   
            
            
        </td>
        <td class="text-truncate" (click)="detailedIOnfo(consent.requestId)" *ngIf="(consent.requestTypeName == 'Non-Returnable' && (consent.status=='Received' || consent.status=='Cancelled'))">
          <span style="display: flex;justify-content: center;" class="showellipsis">-</span>                
        </td>
     
        <td class="text-truncate" (click)="detailedIOnfo(consent.requestId)" *ngIf="duedatecomparer>consent.returnDateTime && (consent.statusId!=OutwardStatus.Received && consent.statusId!=OutwardStatus.Cancelled)">
          <span *ngIf="consent.requestTypeName != 'Non-Returnable'" style="color: red;">{{consent.returnDateTime | date:'d/MMM/y, h:mm a'}}  
             <img src="../../../../assets/images/OIP.jpg" style="width:14px">
          </span>
          <span style="display: flex;justify-content: center;" class="showellipsis" *ngIf="consent.requestTypeName == 'Non-Returnable'">-</span>                
      </td>
        <!-- <td class="tablewidth" *ngIf="Roles=='Security Supervisor'">
          <span class="showellipsis"  >{{consent.cityName}}</span>
        </td>
        <td class="tablewidth" *ngIf="Roles=='Security Supervisor'">
          <span class="showellipsis"  >{{consent.officeName}}</span>
        </td> -->
        <td style="width:100px;" class="d-flex">
          <div *ngIf="consent.requestTypeName === 'Returnable' && consent.statusId !== OutwardStatus.Received && consent.statusId !== OutwardStatus.Declined " tooltip="Edit Request">
            <i  class="icon-ic_edit"  style="padding-top: 5px;float: right; 
                    padding-right: 18px;" (click)="editOutwardReq(consent.requestId)"></i>
          </div>
          <div style="flex:1" *ngIf="consent.requestTypeName !== 'Returnable' && consent.statusId===OutwardStatus.Created " tooltip="Edit Request">
            <i  class="icon-ic_edit"  style="padding-top: 5px;float: right; 
                    padding-right: 18px;" (click)="editOutwardReq(consent.requestId)"></i>
          </div>       
          <div style="flex:1" *ngIf="consent.statusId===OutwardStatus.Created || consent.statusId===OutwardStatus.Declined">
                <img src="../../../../assets/images/delete.png" (click)="deleteReg(consent.requestId,consent.requestName,consent)" class="show-cursor" [alt]="X"/>
          </div> 
          <div style="flex:1" (click)="detailedIOnfo(consent.requestId)" *ngIf="consent.statusId!=OutwardStatus.Created && consent.statusId!=OutwardStatus.Cancelled && consent.statusId!=OutwardStatus.Received"></div>
          <div style="flex:1" *ngIf="consent.statusId!=OutwardStatus.Cancelled && consent.statusId!=OutwardStatus.Declined && consent.statusId!=OutwardStatus.Supervisor && consent.statusId!=OutwardStatus.PrintPass && consent.statusId!=OutwardStatus.Received" tooltip="Cancel Request">
            <div class="Deletebtn" (click)="DeclineRequest(consent)">
              <div class="BoxOne">
                <img   src="../../../../assets/images/x.svg"  class="show-cursor" style="width:21px;"/>
              </div>
            </div>
          </div> 
        </td>
        <!-- <td *ngIf="consent.statusId == OutwardStatus.Received"></td>
        <td *ngIf="consent.statusId == OutwardStatus.Received"></td> -->
        </tr>
          </tbody>
      </table>
    </div>
    <div class="paginationwithcount" *ngIf="((usersList!=null)&&(usersList.length>0))" (click)="hideDropdowns()">
        <span class="mb-4 mx-4">Page</span>
        <pagination 
                    [(ngModel)]="filterData.page"
                    [boundaryLinks]="true" 
                    (pageChanged)="changeCurrentPage($event);p = $event"
                    [(totalItems)] = "totalCount"
                    [maxSize]="5"
                    firstText="&shy;"
                    lastText="&shy;"
                    previousText="&shy;"
                    nextText="&shy;"
                    [rotate]="false"
                    [itemsPerPage] = "itemsperPage"
                    >
        </pagination>  
    </div>
    <div class="totalcount" *ngIf="((usersList!=null)&&(usersList.length>0))"><span>{{((filterData.page -1) * itemsperPage )+ 1}} - {{ countLength }} of <b>{{totalCount}}</b></span></div>
</div>
<!-- <ng-template #tooltipTpl style="border:0;margin-left:-6px;" >
<img src="../../../../assets/images/created.png" style="width:750px;right:25px;height:40px;margin-left:0px;padding-left: 0px;">
  
</ng-template>
<ng-template #tooltipTplappr1 style="border:0;margin-left:-6px;" >
  <img src="../../../../assets/images/Laappr1.PNG" style="width:625px;right:25px;">
  </ng-template>
  <ng-template #tooltipTplappr2 style="border:0;margin-left:-6px;" >
    <img src="../../../../assets/images/laapr2.PNG" style="width:625px;right:25px;">
    </ng-template>
    <ng-template #tooltipTplsuper style="border:0;margin-left:-6px;" >
      <img src="../../../../assets/images/supervisor.PNG" style="width:625px;right:25px;">
      </ng-template>
      
      <ng-template #tooltipTplprint style="border:0;margin-left:-6px;" >
        <img src="../../../../assets/images/passprinted.PNG" style="width:625px;right:25px;">
        </ng-template>

        
      <ng-template #tooltipTplreceived style="border:0;margin-left:-6px;" >
        <img src="../../../../assets/images/received.PNG" style="width:625px;right:25px;">
        </ng-template> -->
